import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  root: {},
}))
